import React from 'react'
import { Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useEmptySearchComponentComponentStyles } from './empty-search-result.component.styles'
import SearchIcon from '@material-ui/icons/Search'

export type EmptySearchResultProps = {
  /** Primary heading */
  title?: string
  /** Supporting copy (omitted if not set) */
  description?: string
  /** @deprecated use `title` */
  text?: string
  icon?: React.ElementType
}

export const EmptySearchResultComponent: React.FC<EmptySearchResultProps> = (
  props
) => {
  const { title, description, text, icon: Icon = SearchIcon } = props
  const { t } = useTranslation()
  const classes = useEmptySearchComponentComponentStyles()

  const resolvedTitle =
    title ?? text ?? t('emptySearchResult.title')

  return (
    <div className={classes.card}>
      <div className={classes.inner}>
        <div className={classes.iconWrap} aria-hidden>
          <Icon className={classes.icon} />
        </div>
        <Typography component="h2" variant="h6" className={classes.title}>
          {resolvedTitle}
        </Typography>
        {description ? (
          <Typography component="p" variant="body1" className={classes.description}>
            {description}
          </Typography>
        ) : null}
      </div>
    </div>
  )
}
